export const enum ApprovalPriority {
    NORMAL = 'Normal',
    URGENT = 'Urgent',
}

export enum ApprovalStatus {
    ACCEPTED = "Accepted",
    APPROVED = "Approved",
    APPROVED_WIP = "Approved - WIP",
    APPROVED_DES_REJECT = "Approved - Design Rejected",
    CANCELLED = "Cancelled",
    COMPLETE = "Complete",
    DES_COMPLETE = "DES Complete",
    FINISHED = "Finished",
    REJECTED = "Rejected",
    REJECT = "Reject",
    REWORK = "Rework",
    REWORK_REQUESTED = "Rework Requested",
    PENDING = "Pending",
    WAIVED = "Waived",
    ONHOLD = "OnHold",
}

export enum RequestStatus {
    ACCEPTED = "Accepted",
    APPROVED = "Approved",
    AWAITING_REVIEW = "Awaiting Review",
    AWAITING_APPROVAL = "Awaiting Approval",
    CANCELLED = "Cancelled",
    CANCELLED_AWAITING = "Cancelled/Awaiting PL Assignment",
    COMPLETE = "Complete",
    INITIAL = "Initial Request",
    REJECTED = "Rejected",
    REWORK_REQUESTED = "Rework Requested",
    REWORK_IN_PROGRESS = "Rework in Progress",

}

